import { connect } from 'react-redux';
import { toggleReactionToComment } from '../../redux/actionCreators';
const mapDispatchToProps = {
    toggleReactionToComment
};
export default connect(null, mapDispatchToProps);
